<template>
	<div class="image-message" @click="dialog = true">
		<v-dialog
			v-model="dialog"
			content-class="elevation-0"
		>
			<v-card
				rounded
				max-width="800"
				max-height="800"
				flat
				color="transparent"
				class="d-flex align-center justify-center"
				@click="dialog = false"
			>
				<v-img
					:src="src"
					:lazy-src="loading ? require('@/assets/placeholder-image.png') : null"
					width="100%"
					height="100%"
					min-width="80"
					min-height="80"
					max-width="100%"
					max-height="100%"
					contain
					class="rounded"
				/>
			</v-card>
		</v-dialog>

		<v-progress-circular
			v-if="loading"
			indeterminate
			color="grey darken-2"
			size="34"
			width="2"
			class="image-loader"
		/>
		<v-img
			:src="src"
			lazy-src="@/assets/placeholder-image.png"
			width="150"
			height="150"
			min-width="100"
			min-height="100"
			max-width="400"
			max-height="400"
			class="rounded"
		/>
	</div>
</template>

<script>
export default {
	name: 'ImageMessage',
	props: {
		src: { type: String, default: '' }
	},

	data() {
		return {
			loading: false,
			dialog: false,
		}
	},

	watch: {
		src: {
			handler(val) {
				if (val) {
					this.loading = true;
					let img = new Image();
					img.src = val;
					img.onload = () => {
						this.loading = false;
						img = null;
					}
				}
			},
			immediate: true,
		}
	}
};
</script>

<style lang="scss">
.image-message {
	display: flex;
	justify-content: center;
	align-items: center;
	object-fit: cover;

	min-height: 80px;
	min-width: 80px;
	max-width: 400px;
	max-height: 400px;

	cursor: pointer;

	.image-loader {
		position: absolute;
		z-index: 1;
	}
}
</style>